export default "/fonts/vendor/katex/dist/KaTeX_Math-BoldItalic.woff2?dcbcbd93bac0470b462db6f9708a658c";